import { render, staticRenderFns } from "./digitalarchive.vue?vue&type=template&id=2f334468&scoped=true&"
import script from "./digitalarchive.vue?vue&type=script&lang=js&"
export * from "./digitalarchive.vue?vue&type=script&lang=js&"
import style0 from "./digitalarchive.vue?vue&type=style&index=0&id=2f334468&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f334468",
  null
  
)

export default component.exports